import { defineStore } from 'pinia';
import { AiChat } from '@/utils/ai/aikpAiEngine.es.js';
import { v4 as uuidv4 } from 'uuid';

const uuid = uuidv4();

interface State {
  headersConfig: Record<string, string>;
  aiChat: typeof AiChat | null;
  history: string[];
  isDeepThinkEnabled: boolean;
}
const useAiStore = defineStore('KePuAi', {
  state: (): State => ({
    headersConfig: {
      'x-trace-id': uuid,
      'x-user-id': '',
      'x-device-id': uuid,
      'x-user-tag': '',
      'x-platform': 'web',
      'x-appid': 'kpyjy-kpzgapp',
      authorization: '',
    },
    aiChat: null,
    history: [],
    isDeepThinkEnabled: false,
  }),
  getters: {},
  actions: {
    async init(uid: string) {
      this.headersConfig['x-user-id'] = uid;
      this.headersConfig['x-user-tag'] = uid;
      this.aiChat = new AiChat();
      this.aiChat.reinitConfig();
      // 初始化基础配置
      await this.aiChat.initConfig(
        {
          userId: uid || '',
        },
        () => {
          console.log('initConfig error');
        }
      );
      // 初始化大模型助手
      this.aiChat.initAssistant();

      console.log(
        '🚀 ~ this.aiChat.baseConfig:',
        JSON.stringify(this.aiChat.baseConfig)
      );

      const authorization = `Bearer ${this.aiChat.baseConfig?.accessToken ?? ''}`;
      this.headersConfig['authorization'] = authorization;
      this.aiChat.setUserConfig({
        userId: this.headersConfig['x-user-id'] || '',
        deviceId: this.headersConfig['x-device-id'] || '',
        appId: this.headersConfig['x-appid'] || 'kpyjy-kpzgapp',
        authorization,
      });
      console.log(123, this.headersConfig);
      this.aiChat.setChatHistoryHeaders(this.headersConfig);
    },
  },
  persist: true,
});

export default useAiStore;
